export default __webpack_public_path__ + "bc931cc434810bf5a286b0c12e2aa588.png";